exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CarouselModal-2750e5fa .ctaContainer-5ac06ed2{margin:auto;text-align:center;display:flex;justify-content:space-around}.CarouselModal-2750e5fa .TipsCarousel-09a52193{text-align:center;color:#424242;padding-left:1em;padding-right:1em}.CarouselModal-2750e5fa .TipsCarousel-09a52193 .title-d08106c9{margin-top:1em;margin-bottom:1em;text-transform:uppercase;font-weight:bold;color:#9E9E9E;letter-spacing:.2rem}.CarouselModal-2750e5fa .TipsCarousel-09a52193 .imgContainer-798a60c6 img,.CarouselModal-2750e5fa .TipsCarousel-09a52193 .imgContainer-798a60c6 video{height:30vh}\n", ""]);

// Exports
exports.locals = {
	"CarouselModal": "CarouselModal-2750e5fa",
	"ctaContainer": "ctaContainer-5ac06ed2",
	"TipsCarousel": "TipsCarousel-09a52193",
	"title": "title-d08106c9",
	"imgContainer": "imgContainer-798a60c6"
};